import { render } from "./StatusesTab.vue?vue&type=template&id=206dc0dc&scoped=true"
import script from "./StatusesTab.vue?vue&type=script&lang=js"
export * from "./StatusesTab.vue?vue&type=script&lang=js"

import "./StatusesTab.vue?vue&type=style&index=0&id=206dc0dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206dc0dc"]])

export default __exports__